import { AsyncButton, SaveStates } from '@infl-ts/ui-advocate-components';
import { useMutationMapper } from '@infl-ts/util-use-mutation-mapper';
import * as E from 'fp-ts/Either';
import StageLayout from '../stage-layout';
import { jsx as _jsx } from "react/jsx-runtime";

var AdvocateWorkflow = function AdvocateWorkflow(_ref) {
  var stage = _ref.stage,
      activity = _ref.activity,
      completeStage = _ref.completeStage,
      completeStageStatus = _ref.completeStageStatus,
      prospect = _ref.prospect;
  var Saving = SaveStates.Saving,
      Default = SaveStates.Default,
      Success = SaveStates.Success,
      Error = SaveStates.Error;
  var mutationValue = useMutationMapper(completeStageStatus, function (_ref2) {
    var completeStage = _ref2.completeStage;
    return completeStage.__typename === 'CompleteStageErrors' ? E.left(completeStage) : E.right(completeStage);
  }, [Saving, Success, Error, Default]);
  return /*#__PURE__*/_jsx(StageLayout, {
    stage: stage,
    prospect: prospect,
    actions: /*#__PURE__*/_jsx(AsyncButton, {
      text: ['Submitting...', 'Saved', stage.completionText || 'Next', stage.completionText || 'Next'],
      status: mutationValue,
      onClick: function onClick() {
        return completeStage({
          advocateAcceptanceInput: {
            stageID: stage.id,
            activityID: activity === null || activity === void 0 ? void 0 : activity.id
          }
        });
      }
    }),
    "data-element": "StageLayout",
    "data-component": "AdvocateWorkflow",
    "data-source-file": "index.tsx"
  });
};

export default AdvocateWorkflow;